import {Injectable} from '@angular/core';
import {GtLocalStorageService} from '@app/services/gt-localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class GtPageSizeService {
  pageSizeKey = 'pageSize';
  readonly defaultPageSize = 10;

  constructor(private localStorageService: GtLocalStorageService) {}

  setPageSize(tableName: string, value: number) {
    const userData = this.localStorageService.getUserItem(this.pageSizeKey);
    const pageSizes = JSON.parse(userData);
    if (pageSizes) {
      pageSizes[tableName] = value;
      this.localStorageService.setUserItem(this.pageSizeKey, JSON.stringify(pageSizes));
    } else {
      this.localStorageService.setUserItem(this.pageSizeKey, JSON.stringify({[tableName]: value}));
    }
  }

  getPageSize(tableName: string, defaultPageSize?: number): number {
    const userData = this.localStorageService.getUserItem(this.pageSizeKey);
    const pageSizes = JSON.parse(userData);
    if (pageSizes && tableName in pageSizes) {
      return pageSizes[tableName];
    }
    return defaultPageSize || this.defaultPageSize;
  }
}
